import { useState, useEffect } from "react";
import Player from "../../player/player-static";
import PosterItem from "./posterItem";

const Poster = ({ data, apiUrl }) => {
  const [selectedIndex, setSelectedIdex] = useState(0);
  const [error, setError] = useState("");
  const [playerOpen, setPlayerOpen] = useState(false);
  const [itemData, setItemData] = useState({});

  const openPlayer = (item) => {
    setItemData(item);
    setPlayerOpen(true);
  };

  const closePlayer = () => {
    setPlayerOpen(false);
  };

  const selectItem = (index) => {
    setSelectedIdex(index);
  };

  useEffect(()=>{
    if(data.settings.autoAdvance && data.content.length>1){
      setInterval(()=>{
        setSelectedIdex(currentIndex => currentIndex===data.content.length-1 ? 0 : currentIndex+1);
      },data.settings.interval);
    }
  },[])

  if (error) {
    return (
      <div className="w-full h-full flex justify-center items-center">
        <div className="bg-black/90 p-5 rounded-md">
          <span className="text-white">{error}</span>
        </div>
      </div>
    );
  } else {
    return (
      <div
        id={`widget-${data.id}`}
        className="overflow-y-hidden w-full relative select-none"
        style={{paddingTop: data.settings.aspect}}
      >
        {data.content.map((item, index) => (
          <PosterItem
            key={item.id}
            item={item}
            settings={data.settings}
            selected={index === selectedIndex}
            onClick={openPlayer}
          />
        ))}
        {data.content.length>1 && <div className="vf-poster-page-indicators flex absolute bottom-0 justify-center z-20 w-full from-black/20 to-transparent bg-gradient-to-t">
          {data.content.map((item, index) => (
            <div
              key={index}
              className="h-10 group flex flex-1 justify-center items-center cursor-pointer px-1"
              onClick={() => {
                selectItem(index);
              }}
            >
              <div
                className={`vf-poster-page-indicator w-full h-1 group-hover:bg-white/75 ${
                  index === selectedIndex ? "bg-white" : "bg-white/50"
                }`}
              ></div>
            </div>
          ))}
        </div>}
        {playerOpen && <Player onClose={closePlayer} item={itemData} widgetToken={data.id} settings={data.settings} apiUrl={apiUrl} />}
      </div>
    );
  }
};

export default Poster;
